import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { SharedModule } from '@app/shared';
import { W4formRoutingModule } from '@app/w4-form//w4form-routing.module';
import { W4formComponent } from '@app/w4-form/w4form.component';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [W4formComponent],
  imports: [
    CommonModule,
    ConfirmDialogModule,
    DialogModule,
    W4formRoutingModule,
    SharedModule,
    FormsModule,
    FontAwesomeModule,
  ],
  exports: [W4formComponent],
  providers: [ConfirmationService],
})
export class W4formModule {
  constructor() {
    // library.addIcons(faCaretRight);
  }
}
